import removeWaveDecoration from '../../../js/src/__page/backgroundInnerBlocks';

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		removeWaveDecoration();
	},
	loaded() {},
	resized() {
		removeWaveDecoration();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
